import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";
import PageHeader from "../components/PageHeader";
import facilityFront from "../assets/photos/facility-front.jpeg";
import facilityEntrance from "../assets/photos/facility-entrance.jpeg";
import signboardEnglish from "../assets/photos/signboard-english.jpeg";
import signboardGujarati from "../assets/photos/signboard-gujarati.jpeg";
import cuminImg from "../assets/products/cumin.webp";
import fennelImg from "../assets/products/fennel.jpg";
import corianderImg from "../assets/products/coriander.jpg";
import blackSesameImg from "../assets/products/black-sesame.webp";
import whiteSesameImg from "../assets/products/white-sesame.jpg";
import redChillyImg from "../assets/products/red-chilly.webp";
import "./Gallery.css";

const gallery = [
  {
    src: facilityFront,
    caption: "Our facility — Mothla, Naliya–Bhuj Road, Kutch",
    cat: "Facility",
  },
  {
    src: signboardEnglish,
    caption: "Agronexus Trading Pvt. Ltd. — official signboard",
    cat: "Facility",
  },
  {
    src: facilityEntrance,
    caption: "Warehouse entrance — ready for loading",
    cat: "Facility",
  },
  {
    src: signboardGujarati,
    caption: "Signboard in Gujarati — એગ્રોનેક્સસ ટ્રેડિંગ",
    cat: "Facility",
  },
  {
    src: cuminImg,
    caption: "Cumin seeds (Jeera) — Gujarat & Rajasthan origin",
    cat: "Product",
  },
  {
    src: redChillyImg,
    caption: "Red chilly (Lal Mirch) — Teja, Sannam & Kashmiri varieties",
    cat: "Product",
  },
  {
    src: corianderImg,
    caption: "Coriander seeds (Dhaniya) — Rajasthan origin",
    cat: "Product",
  },
  {
    src: fennelImg,
    caption: "Fennel seeds (Saunf) — Gujarat origin",
    cat: "Product",
  },
  {
    src: blackSesameImg,
    caption: "Black sesame seeds (Kala Til) — Gujarat origin",
    cat: "Product",
  },
  {
    src: whiteSesameImg,
    caption: "White sesame seeds (Safed Til) — hulled & natural grades",
    cat: "Product",
  },
];

const categories = ["All", "Facility", "Product"];

function Gallery() {
  const [filter, setFilter] = useState("All");
  const [lightbox, setLightbox] = useState(null);

  const filtered =
    filter === "All" ? gallery : gallery.filter((g) => g.cat === filter);

  return (
    <motion.main
      className="page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <PageHeader
        eyebrow="Gallery"
        title="From <em>field, facility,</em> and freight."
        subtitle="A visual record of what we do and where it happens — growing belts, grading lines, packing floors, and port operations."
      />

      <section className="section">
        <div className="container">
          <div className="gallery-filters">
            {categories.map((c) => (
              <button
                key={c}
                className={`gallery-filter ${
                  filter === c ? "gallery-filter--active" : ""
                }`}
                onClick={() => setFilter(c)}
              >
                {c}
              </button>
            ))}
          </div>

          <motion.div className="gallery-grid" layout>
            <AnimatePresence>
              {filtered.map((item, i) => (
                <motion.button
                  key={item.src}
                  className={`gallery-item gallery-item--${(i % 4) + 1}`}
                  onClick={() => setLightbox(item)}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.4, delay: i * 0.04 }}
                >
                  <img src={item.src} alt={item.caption} />
                  <div className="gallery-item__overlay">
                    <span className="gallery-item__cat">{item.cat}</span>
                    <span className="gallery-item__caption">
                      {item.caption}
                    </span>
                  </div>
                </motion.button>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            className="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
          >
            <button
              className="lightbox__close"
              onClick={() => setLightbox(null)}
              aria-label="Close"
            >
              <FiX />
            </button>
            <motion.img
              src={lightbox.src}
              alt={lightbox.caption}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.4 }}
              onClick={(e) => e.stopPropagation()}
            />
            <p className="lightbox__caption">{lightbox.caption}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.main>
  );
}

export default Gallery;
